import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=c8b4ecf0&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b4ecf0')) {
      api.createRecord('c8b4ecf0', component.options)
    } else {
      api.reload('c8b4ecf0', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=c8b4ecf0&", function () {
      api.rerender('c8b4ecf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FyrwVAet4nt3/JS/comp/childrenage.vue"
export default component.exports